/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free: NonNullable<unknown> }} Applicants_Bulk_Accept_Not_Enough_SlotsInputs */

const en_applicants_bulk_accept_not_enough_slots = /** @type {(inputs: Applicants_Bulk_Accept_Not_Enough_SlotsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not enough free slots (${i?.free} available)`)
};

const de_applicants_bulk_accept_not_enough_slots = /** @type {(inputs: Applicants_Bulk_Accept_Not_Enough_SlotsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nicht genug freie Slots (${i?.free} verfügbar)`)
};

/**
* | output |
* | --- |
* | "Not enough free slots ({free} available)" |
*
* @param {Applicants_Bulk_Accept_Not_Enough_SlotsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_accept_not_enough_slots = /** @type {((inputs: Applicants_Bulk_Accept_Not_Enough_SlotsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Accept_Not_Enough_SlotsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_accept_not_enough_slots(inputs)
	return en_applicants_bulk_accept_not_enough_slots(inputs)
});